import React from 'react';
import { twMerge } from 'tailwind-merge';
import { withField } from './withField';

export interface SelectOption {
  name: string;
  value?: any;
  color?: string;
}

interface InjectedProps {
  value: any;
  onChange: (newValue: any) => void;
  placeholder?: string;
}

interface Props extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'value' | 'onChange'> {
  options: SelectOption[];
  readOnly?: boolean;
  className?: string;
  defaultValue?: string;
  placeholder?: string;
}

export const SelectInput = React.forwardRef<HTMLSelectElement, Props & InjectedProps>(
  (
    { options, value, onChange, readOnly, className, defaultValue = '-', placeholder = 'Select an option', ...props },
    ref
  ) => {
    if (readOnly) {
      const selectedOption = options.find(opt => opt.value === value);

      return (
        <div
          className={twMerge(className, 'bg-background py-2 px-3 flex items-center border border-border rounded-md')}
        >
          {selectedOption?.name || defaultValue}
        </div>
      );
    }

    return (
      <select
        ref={ref}
        value={value}
        onChange={event => onChange(event.target.value)}
        className={twMerge(className, 'border-primary-std rounded-md overflow-hidden text-ellipsis')}
        {...props}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}

        {options.map(option => (
          <option
            key={option.value}
            value={option.value}
            style={{
              background: option.color,
              fontWeight: option.color ? 'bold' : undefined
            }}
          >
            {option.name}
          </option>
        ))}
      </select>
    );
  }
);

export const SelectInputField = withField<string, Props>(SelectInput);
